











import { Component, Vue, Prop } from 'vue-property-decorator';
import PanelActionButton, {
  PanelActionButtonItemType,
} from '@/components/atoms/PanelActionButton.vue';
import { i18n } from '@/plugins/i18n/i18n';

@Component
export default class HoverDescription extends Vue {
  @Prop()
  private title!: string;

  @Prop()
  private description!: string;
}
